import styled from 'styled-components'
import Threshold from 'constants/threshold'
import Colors from 'constants/colors'

export const ArtistPageWrapper = styled.main<{ isMarginTop: boolean }>`
  width: 88%;
  margin: ${({ isMarginTop }) => (isMarginTop ? '120px' : '0')} auto 0;
  max-width: 1060px;

  .mobile g image {
    width: auto;
    /* transform: translateX(-50%); */
  }

  & .socials-row {
    display: flex;
  }

  @media (min-width: ${Threshold.phone}) {
    margin: ${({ isMarginTop }) => (isMarginTop ? '120px' : '0')} auto 28px;
  }
`

export const ArtistName = styled.h1`
  margin-bottom: 30px;
`

export const  ArtistGenre = styled.h2`
font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-transform: none;
  color: ${Colors.red};
`

export const ArtistCity = styled.h2`
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-transform: none;
  margin-bottom: 30px;

  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 60px;
  }
`

export const ArtistDescription = styled.p`
  margin-bottom: 40px;
  line-height: 22px;
  @media (min-width: ${Threshold.phone}) {
    font-size: 20px;
    line-height: 35px;
    margin-bottom: 60px;
  }
`

export const ProjectTitle = styled.h2`
  line-height: 30px;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;

  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 30px;
    font-size: 35px;
  }
`

export const ProjectName = styled.h2`
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-transform: none;
  margin-bottom: 20px;

  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 30px;
  }
`

export const ProjectDescription = styled.p`
  margin-bottom: 20px;
  overflow-wrap: break-word;
  white-space: pre-line;

  @media (min-width: ${Threshold.phone}) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 40px;
  }
`

export const Slash = styled.img`
  height: 30px;
  margin: 0 auto 20px;

  @media (min-width: ${Threshold.phone}) {
    margin: 0 auto 26px;
  }
`

export const SocialsRow = styled.div`
  display: flex;
`
export const SocialIcons = styled.div`
  max-width: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  & a {
    margin: 0 12px 20px;
    cursor: pointer;

    @media (min-width: ${Threshold.phone}) {
      margin: 0 12px 32px;
    }

    & img {
      transition-duration: 0.2s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }
`

export const WinnerIcon = styled.img`
  width: 30px;
  height: 30px;
  margin: 0 auto 30px;

  @media (min-width: ${Threshold.phone}) {
    width: 50px;
    height: 50px;
  }
`

export const PlaylistWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;

  @media (min-width: ${Threshold.tablet}) {
    max-width: 60%;
  }
`
